import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { unpublishPlace } from '../../api/place.ts';

export default function useUnpublishPlace(): UseMutationResult<
  Awaited<ReturnType<typeof unpublishPlace>>,
  Error
> {
  return useMutation({
    mutationFn: unpublishPlace,
  });
}
